<template>
    <!-- The status region stays mounted and the bar is added into it: a live
         region rendered together with its text, as v-if did, often isn't
         announced at all. -->
    <div role="status">
        <div class="offline-bar" v-if="!isOnline">
            <p class="body-small">Offline &middot; showing saved data</p>
        </div>
    </div>
</template>

<script setup>
    // Reads the shared connectivity state from useOnlineStatus() (Task 6).
    // Mounted in default.vue + archives.vue only (not bare.vue, which is used
    // by /offline and must stay dependency-free).
    const { isOnline } = useOnlineStatus();
</script>

<style lang="scss" scoped>
    // Bottom of the screen, not the top: at top: 0 it sat over the fixed
    // header (z-index 500 against 99), hiding the search, account,
    // notifications and menu buttons for exactly as long as the visitor was
    // offline. Padded clear of the iPhone home indicator and, in landscape,
    // the notch.
    .offline-bar {
        z-index: $zStepFive;
        position: fixed;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 8px max(15px, env(safe-area-inset-right)) calc(8px + env(safe-area-inset-bottom)) max(15px, env(safe-area-inset-left));
        background-color: $gray-darkest;
        color: white;
        text-align: center;

        p {
            margin: 0;
        }
    }
</style>
